<template>
    <div class="relative min-h-10">
        <!-- eslint-disable-next-line -->
        <div v-html="content" v-bind="$attrs"></div>
        <PreviewLoader v-if="loading.content" />
    </div>
</template>

<script setup lang="ts">
import { toRefs, onMounted, ref, watch } from 'vue';
import PreviewLoader from './PreviewLoader.vue';

interface Props {
    type?: number | string;
    value?: any;
}

const props = withDefaults(defineProps<Props>(), {
    type: 0,
    value: {},
});

const { type, value } = toRefs(props);

const loading = ref({
    content: true,
});

const content = ref(null);

const loadContent = () => {
    loading.value.content = true;

    const formData = new FormData();

    for (const key in value.value) {
        if (Object.prototype.hasOwnProperty.call(value.value, key)) {
            const fieldValue = value.value[key];

            if (fieldValue instanceof File || fieldValue instanceof Blob) {
                formData.append(`value[${key}]`, fieldValue);
            } else if (typeof fieldValue === 'object' && fieldValue !== null) {
                formData.append(`value[${key}]`, JSON.stringify(fieldValue));
            } else if (fieldValue !== undefined) {
                formData.append(`value[${key}]`, fieldValue);
            }
        }
    }

    formData.append('admin', 'true');

    axios
        .post(route('content.types.render', { id: type.value }), formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        .then(({ data }) => {
            content.value = data.content;
            loading.value.content = false;
        });
};

let loadContentTimeout = null;

const deferredLoadContent = () => {
    clearTimeout(loadContentTimeout);
    loadContentTimeout = setTimeout(() => {
        loadContent();
    }, 500);
};

onMounted(() => {
    loadContent();
});

watch(type, () => {
    loadContent();
});

watch(
    value,
    () => {
        deferredLoadContent();
    },
    { deep: true },
);
</script>
